(() => {
  const almaMerchantId = window.almaConfig.merchantId;
  const apiMode = Alma.ApiMode.LIVE;
  const widgets = Alma.Widgets.initialize(almaMerchantId, apiMode);
  let modalFunctions = getModalFunctions(window.almaConfig.initialVariantPrice);

  document.querySelector('.product__reinsurance').addEventListener('click', handleModalOpen);

  console.log({
    installmentsCount: 3,
    deferredDays: 0,
    minAmount: window.almaConfig.minPrice,
    maxAmount: window.almaConfig.maxPrice,
  });
  function getModalFunctions(purchaseAmount) {
    return widgets.add(Alma.Widgets.Modal, {
      container: '#alma-widget-modal',
      purchaseAmount,
      locale: window.Shopify.locale,
      plans: [
        {
          installmentsCount: 3,
          minAmount: window.almaConfig.minPrice,
          maxAmount: window.almaConfig.maxPrice,
        },
      ],
    });
  }

  function handleModalOpen(event) {
    const modalOpener = event.target.closest('button:not(.splide__pagination__page):not(.splide__arrow)');
    if (modalOpener) {
      modalFunctions.open();
    }
  }
})();